import BaseModel from './BaseModel';

export default class Temperature extends BaseModel {
  constructor(
    public value: number,
    public valueIntPart: number,
    public valueDoublePart: number
  ) {
    super();
  }

  toString(): string {
    return `Temperature: ${this.value}`;
  }

  toJSON() {
    return {
      value: this.value,
      valueIntPart: this.valueIntPart,
      valueDoublePart: this.valueDoublePart,
    };
  }
}
